import React, { useEffect, useState } from "react";

import { Box, ButtonBase, Theme } from "@mui/material";

import { CheckRounded, ContentCopyRounded } from "@mui/icons-material";

import { MONO_FONT, focusRing } from "../tokens";

export function monoChipDisplay(value: string, display?: string): string {
  return display ?? value;
}

export const MonoChip = ({
  value,
  display,
  withBackground = false,
  withIcon = false,
}: {
  value: string;
  display?: string;
  withBackground?: boolean;
  withIcon?: boolean;
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const id = window.setTimeout(() => setCopied(false), 900);
    return () => window.clearTimeout(id);
  }, [copied]);

  function copy(event: React.MouseEvent) {
    event.stopPropagation();
    void navigator.clipboard?.writeText(value);
    setCopied(true);
  }

  const baseSx = (theme: Theme) => ({
    fontFamily: MONO_FONT,
    fontSize: theme.typography.caption.fontSize,
    color: copied ? theme.palette.grey[900] : theme.palette.grey[700],
    whiteSpace: "nowrap" as const,
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    ...(withBackground
      ? {
          backgroundColor: theme.palette.grey[300],
          borderRadius: "5px",
          padding: "1px 6px",
        }
      : {}),
  });

  const content = monoChipDisplay(value, display);

  return (
    <ButtonBase
      onClick={copy}
      aria-label={`Copy ${value}`}
      title="Copy"
      sx={(theme) => ({
        ...baseSx(theme),
        cursor: "copy",
        "&:hover": { color: theme.palette.grey[900] },
        ...focusRing(theme),
      })}
    >
      {content}
      {withIcon &&
        (copied ? (
          <CheckRounded sx={{ width: "11px", height: "11px" }} />
        ) : (
          <ContentCopyRounded sx={{ width: "11px", height: "11px" }} />
        ))}
    </ButtonBase>
  );
};
